<template>
  <div class="box" @keyup.enter="_save" @keyup.esc="_cancel" @keyup.delete="_delete">
    <b-field label="Idegen">
      <b-input id="inp1" v-model="orig" />
    </b-field>
    <b-field label="Magyar">
      <b-input id='inp2' v-model="hun" type="textarea" />
    </b-field>
    <div class="buttons is-pulled-left">
      <b-button @click="_save" type="">Mentés</b-button>
      <b-button @click="_cancel">Mégsem</b-button>
    </div>
    <div class="buttons is-centered">
      <b-button @click="_delete" type="is-danger" icon-left="trash">Törlés</b-button>
    </div>
  </div>
</template>

<script>
import DictSvc from '@/services.js'

export default {
  name: 'Edit',
  data: function() {
    return {
      lang : '',
      orig : '',
      hun : '',
      transl : '',
      mono : '',
      id : 0,
      idx : 0,
      prons1 : '',
      prons2 : '',
    }
  },
  computed: {
    webster() {
      return this.mono.replace(/\n/g, '<br />')
    },
    list() { return this.$store.state.list}
  },
  components: {
  },
  watch: {
    $route() {
      this.refresh()
    }
  },
  methods: {
    _save: function () {
      if (!(this.orig == '' || this.hun == '')) {
        DictSvc.update(this.id, this.orig, this.hun)
        .then(() => {
          var defi = this.list[this.idx]
          defi.hun = this.hun
          defi.orig = this.orig
          this.$store.commit('UPDATE', defi)
          this.$router.go('-1')
        })
      }
    },
    _cancel: function() {
      this.$router.go('-1')
    },
    _delete: function() {
      this.$buefy.dialog.confirm({
        message: 'Biztos törlöd?',
        onConfirm: this.delete
      })
      document.getElementById('inp1').focus()
    },
    delete: function() {
      DictSvc.delete(this.id)
      .then(() => {
          this.$store.commit('DELETE', this.idx)
          this.$router.go('-1')
      })
    },
    refresh: function() {
      this.idx = this.$store.getters.idx(this.$route.params.id)
      var data = this.list[this.idx]
      this.id = data.id
      this.orig = data.orig
      this.hun = data.hun
      this.lang = data.lang
    },
    _back: function() {
      if (this.idx > 0){
        this.$router.replace('/edit/' + this.list[this.idx - 1].id)
      }
    },
    _forward: function() {
      if (this.idx < this.list.length-1){
        this.$router.replace('/edit/' + this.list[this.idx + 1].id)
      }
    },
    play(sel) {
      document.getElementById(sel).load()
      document.getElementById(sel).play()
    }
  },
  mounted: function() {
    this.refresh()
    document.getElementById('inp1').focus()
  }
}
</script>

<style scoped>
</style>
